import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector, useTranslate, useWidgetParam, useWidgetsTheme } from '../../core/hooks';
import { changeLocation } from '../../core/store';
import { useWidgetId } from '../../core/IdProvider';
import { addCartItemAddedSelector, openCartModal } from '../../features/cart';
import { resetAdderState, closeAdderModal } from '../../features/product';

import { BodyLarge } from '../../fonts/typography/Typography';
import { DarkTextColor } from '../../fonts/typography/TypographyColors';
import { GradientButton } from '../reusable';
import BigCheck from '@src/components/reusable/success/BigCheck';
import useSelectedProductId from '@src/hooks/useSelectedProductId';
import usePackageIdParam from '@src/hooks/usePackageIdParam';

const ProductAdderStatus = () => {
  const { status, errors } = useAppSelector(addCartItemAddedSelector);
  const { i18n } = useTranslate();
  const id = useWidgetId();
  const prodId = useSelectedProductId();
  const errorMessages = Object.values(errors ?? {});
  const actionColor = useWidgetsTheme('actionColor');
  const dispatch = useAppDispatch();
  const autoCheckoutRedirect = useWidgetParam('auto-checkout-redirect');
  const openCartWhenProductAddedParameter = useWidgetParam('open-cart-when-product-added');
  const checkoutPage = useWidgetParam('checkout-page');
  const timeout = useWidgetParam('auto-checkout-redirect-timeout');
  const enableModal = useWidgetParam('enable-modal');
  const packageId = usePackageIdParam();

  const showAsModal = enableModal && enableModal == 'true';

  const openCart = (ev: React.MouseEvent<HTMLAnchorElement>) => {
    ev.preventDefault();

    dispatch(openCartModal());
  };

  const tryAgain = () => dispatch(resetAdderState(id, prodId, packageId));

  useEffect(() => {
    if (!status) {
      return;
    }

    if (autoCheckoutRedirect && checkoutPage) {
      setTimeout(
        () => {
          dispatch(changeLocation(checkoutPage));
        },
        timeout ? +timeout : 3000,
      );
    }

    if (showAsModal || openCartWhenProductAddedParameter === 'true') {
      dispatch(openCartModal());
    }

    dispatch(closeAdderModal(id, packageId));
  }, [status]);

  return (
    <>
      {status ? (
        <SuccessContainer>
          <BigCheck />
          <StatusMessage>{i18n('adder_productAddedToCart')}</StatusMessage>
          <CartAnchor href='#' onClick={openCart}>
            {i18n('adder_seeCart')}
          </CartAnchor>
        </SuccessContainer>
      ) : null}

      {!status && !!errorMessages.length ? (
        <div>
          <StatusMessage>{i18n('adder_productNotAddedToCart')}</StatusMessage>
          {errorMessages.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
          <br />
          <GradientButton actionColor={actionColor} onClick={tryAgain}>
            {i18n('adder_tryAgain')}
          </GradientButton>
        </div>
      ) : null}
    </>
  );
};

const SuccessContainer = styled.div`
  text-align: center;
`;

const StatusMessage = styled.p`
  ${BodyLarge}
  ${DarkTextColor}
    margin: 16px auto;
`;

const CartAnchor = styled.a``;

export default ProductAdderStatus;
